import StarRating from './star-rating';
import ImgixImg from '../imgix-img/connected';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export default (function (_ref) {
  var starNumber = _ref.starNumber,
      value = _ref.value,
      EndIcon = _ref.EndIcon,
      variant = _ref.variant;
  return _jsx(StarRating, {
    starsNumber: starNumber,
    variant: variant,
    EndIcon: _jsx(ImgixImg, {
      entity: EndIcon
    }),
    value: value
  });
});
//# sourceMappingURL=index.js.map